import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";

export default function LogoutConfirmModal({ open, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose}>
     

      <DialogContent>
        <Typography>Are you sure you want to logout?</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
}
